var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 2.50016H13V1.66683C13 1.2085 12.625 0.833496 12.1667 0.833496C11.7083 0.833496 11.3333 1.2085 11.3333 1.66683V2.50016H4.66667V1.66683C4.66667 1.2085 4.29167 0.833496 3.83333 0.833496C3.375 0.833496 3 1.2085 3 1.66683V2.50016H2.16667C1.24167 2.50016 0.508333 3.25016 0.508333 4.16683L0.5 15.8335C0.5 16.7502 1.24167 17.5002 2.16667 17.5002H13.8333C14.75 17.5002 15.5 16.7502 15.5 15.8335V4.16683C15.5 3.25016 14.75 2.50016 13.8333 2.50016ZM13 15.8335H3C2.54167 15.8335 2.16667 15.4585 2.16667 15.0002V6.66683H13.8333V15.0002C13.8333 15.4585 13.4583 15.8335 13 15.8335ZM4.66667 8.3335H7.16667C7.625 8.3335 8 8.7085 8 9.16683V11.6668C8 12.1252 7.625 12.5002 7.16667 12.5002H4.66667C4.20833 12.5002 3.83333 12.1252 3.83333 11.6668V9.16683C3.83333 8.7085 4.20833 8.3335 4.66667 8.3335Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresIcon);
export default __webpack_public_path__ + "static/media/presIcon.f2b0994a.svg";
export { ForwardRef as ReactComponent };